import React from 'react';
import Avatar from '../../common/Avatar';
import { formatDistanceToNow } from 'date-fns';
import { zhTW } from 'date-fns/locale';
import './NotificationPanel.scss';

const NOTIFICATION_ICONS = {
  ticket_assigned: '🎫',
  work_item_assigned: '📌',
  mention: '💬',
  status_change: '🔄',
  new_comment: '💭',
  work_item_comment: '💭',
};

const NotificationPanel = ({
  notifications,
  loading,
  unreadCount,
  onMarkAsRead,
  onMarkAllAsRead,
  onNotificationClick,
  onClose,
  onOpenPreferences,
}) => {
  return (
    <div className="notification-panel">
      <div className="panel-header">
        <h3>通知</h3>
        <div className="panel-header-actions">
          {unreadCount > 0 && (
            <button className="mark-all-btn" onClick={onMarkAllAsRead}>
              全部已讀
            </button>
          )}
          <button
            className="settings-btn"
            onClick={onOpenPreferences}
            title="通知設定"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12.22 2h-.44a2 2 0 00-2 2v.18a2 2 0 01-1 1.73l-.43.25a2 2 0 01-2 0l-.15-.08a2 2 0 00-2.73.73l-.22.38a2 2 0 00.73 2.73l.15.1a2 2 0 011 1.72v.51a2 2 0 01-1 1.74l-.15.09a2 2 0 00-.73 2.73l.22.38a2 2 0 002.73.73l.15-.08a2 2 0 012 0l.43.25a2 2 0 011 1.73V20a2 2 0 002 2h.44a2 2 0 002-2v-.18a2 2 0 011-1.73l.43-.25a2 2 0 012 0l.15.08a2 2 0 002.73-.73l.22-.39a2 2 0 00-.73-2.73l-.15-.08a2 2 0 01-1-1.74v-.5a2 2 0 011-1.74l.15-.09a2 2 0 00.73-2.73l-.22-.38a2 2 0 00-2.73-.73l-.15.08a2 2 0 01-2 0l-.43-.25a2 2 0 01-1-1.73V4a2 2 0 00-2-2z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </button>
        </div>
      </div>

      <div className="panel-body">
        {loading ? (
          <div className="panel-loading">載入中...</div>
        ) : notifications.length === 0 ? (
          <div className="panel-empty">沒有未讀通知</div>
        ) : (
          notifications.map((notification) => (
            <div
              key={notification.id}
              className="notification-item unread"
              onClick={() => onNotificationClick(notification)}
            >
              <div className="notification-icon">
                {notification.actor ? (
                  <Avatar
                    avatarUrl={notification.actor.avatar_url}
                    name={notification.actor.name}
                    size="tiny"
                  />
                ) : (
                  <span className="type-icon">
                    {NOTIFICATION_ICONS[notification.type] || '🔔'}
                  </span>
                )}
              </div>

              <div className="notification-content">
                <div className="notification-title">{notification.title}</div>
                {notification.message && (
                  <div className="notification-message">{notification.message}</div>
                )}
                <div className="notification-time">
                  {formatDistanceToNow(new Date(notification.created_at), {
                    addSuffix: true,
                    locale: zhTW,
                  })}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationPanel;
